<template>
	<div class="container">
		<div class="row">			
			<ul class="wktabdiv row" >
				<li class="wktabtit" v-for="(item,index) in echartTabs" @click="echartTabChange(index)" :class="{active:index == echartCurTab}">
					{{item}}
				</li>
			</ul>
			<div class="wktabtit" style="color: rgb(3, 166, 224);padding: 0;">清洁报告</div>
			<!-- <img src="../../assets/img/download.png" @click="downCsv()" style="height: 30px;width: 40px; align-self: center"/> -->
		</div>
		
		<div class="col">
			<div class="row box">
				<dv-border-box-7 >
					<div class="col box2">
						<font>作业次数</font>
						<div class="row">
							<font class="fontg">{{report.num}} </font>
							<font class="fontsize">次</font>
						</div>					
					</div>
				</dv-border-box-7>				
				<dv-border-box-7>
					<div class="col box2">
						<font>作业天数</font>
						<div class="row">
							<font class="fontg">{{report.totalDays}} </font>
							<font class="fontsize">天</font>
						</div>	
					</div>
				</dv-border-box-7>	
				<dv-border-box-7>
					<div class="col box2">
						<font>环比增长</font>						
						<div class="row">
							<font :class="report.rateWorkDays >= 0 ? 'fontr' :'fontg' ">{{report.rateWorkDays}}</font>
							<font class="fontsize">%</font>
						</div>	
					</div>
				</dv-border-box-7>				
			</div>
			<div class="row box">
				<dv-border-box-7>
					<div class="col box2">
						<font>机器人使用率</font>
						<div class="row">
							<font class="fontg">{{report.rateUse}}</font>
							<font class="fontsize">%</font>
						</div>						
					</div>
				</dv-border-box-7>
				
				<dv-border-box-7>
					<div class="col box2">
						<font>作业完成率</font>					
						<div class="row">
							<font class="fontg">{{report.rateWorkCompleted}}</font>
							<font class="fontsize">%</font>
						</div>	
					</div>
				</dv-border-box-7>
			</div>
			
			<div class="row box">
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">累计清扫面积</font>
						<div class="row">
							<font class="fontg">{{report.area}}</font>
							<font class="fontsize">平方米</font>
						</div>	
					</div>
				</dv-border-box-6>
				<!-- 
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">累计清扫距离</font>						
						<div class="row">
							<font class="fontg">{{report.distance}} </font>
							<font class="fontsize">米</font>
						</div>	
					</div>
				</dv-border-box-6>
				 -->
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">累计清扫时长</font>					
						<div class="row">
							<font class="fontg">{{report.duration}} </font>
							<font class="fontsize">时</font>
						</div>	
					</div>
				</dv-border-box-6>
				
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">累计人力当量</font>					
						<div class="row">
							<font class="fontg">{{report.equalHands}} </font>
							<font class="fontsize">人天</font>
						</div>	
					</div>
				</dv-border-box-6>			
			</div>
			
			<div class="row box">
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">日均清扫面积</font>				
						<div class="row">
							<font class="fontg">{{report.areaAverage}} </font>
							<font class="fontsize">平方米</font>
						</div>	
					</div>
				</dv-border-box-6>
				<!-- 
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">日均清扫距离</font>					
						<div class="row">
							<font class="fontg">{{report.distanceAverage}} </font>
							<font class="fontsize">米</font>
						</div>	
					</div>
				</dv-border-box-6>
				 -->
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">日均清扫时长</font>						
						<div class="row">
							<font class="fontg">{{report.durationAverage}} </font>
							<font class="fontsize">时</font>
						</div>	
					</div>
				</dv-border-box-6>
				
				<dv-border-box-6>
					<div class="col box2">
						<font class="font2">日均人力当量</font>
						<div class="row">
							<font class="fontg">{{report.equalHandsAverage}} </font>
							<font class="fontsize">人天</font>
						</div>	
					</div>
				</dv-border-box-6>			
			</div>
			
			<div class="ranking-container">
				<dv-border-box-8 >
					<div class="row2">
						<div class="nav-title">
							机器人应用排行榜
						</div>
						<div  class="nav-title2"></div>
					</div>
					<div class="row" >
						<font style="width:10%;" >排序</font>
						<font style="width:40%;" >车辆ID</font>
						<font style="width:30%;" >车辆名称</font>
						<font style="width:20%;" >使用率</font>
					</div>
					<div v-for="(item,index) in rateCarUseList" :key="index" class="row carrnaking" style="justify-content: space-around;">
						<div style="width:10%;"><img :src="rateImgList[index]" /></div>
						<div style="width:40%;" >{{item.carId}}</div>
						<div style="width:30%;" >{{item.name}}</div>
						<div style="width:20%;" >{{item.rateCarUse}}</div>
					</div>
				</dv-border-box-8>		   
			</div>  
			
			<div class="col">
				<div ref="chart1" class="mychart-height"></div>
				<div ref="chart2" class="mychart-height"></div>  
			</div>
			
		</div>
	</div>
</template>

<script>
	import echarts from "echarts"
	import {getReport} from '../../api/entity.js'
	
	export default{
		props:{
			selectedEntity:{
				type:String
			}
		},
		watch:{
			selectedEntity:{
				handler(newData){
					if(newData != null && newData != ""){
						this.entityid = newData
						
						this.handleReport()
					}
				},
				immediate: true, //最初绑定值的时候也执行函数
				deep: true //监听一个对象的改变
			}
		},
		components: {
		   scroll
		},
		mounted() {
			// this.handleWeekChange(new Date())
			// this.handleReport()
		},
		data(){
			return{
				entityid:localStorage.getItem('entityid'),
				loginuser:localStorage.getItem('username'),
				
				echartTabs:['上周','本周','上月','本月'],
				echartCurTab:0,
				
				report:{},
				rateCarUseList:[],
				rateImgList:[
					require('../../assets/img/crown1.png'),
					require('../../assets/img/crown2.png'),
					require('../../assets/img/crown3.png')
				],
				listQuery: {
					startTime:'',
					endTime:'',			
					dateType:1
				},
				dateQuery:{
					week:'',
					month:'',
					year:'',
					yearRange: []
				},
			}
		},
		methods:{
			echartTabChange(key){
				this.echartCurTab = key;
				if(key == 0){
					this.handleLastWeekDate(new Date())				
				}else if(key == 1){
					this.handleWeekChange(new Date())
				}else if(key == 2){
					this.handleLastMonthDate(new Date())
				}else if(key == 3){
					this.handleMonthChange(new Date())
				}
				this.handleReport()	
			},
			handleReport(){
				if(this.listQuery.startTime == "" || this.listQuery.endTime == ""){			
					this.handleLastWeekDate(new Date())
				}
				getReport(84,this.entityid, null,this.listQuery).then((res) => {
				   let rs = res.result
				  if(rs == "0"){
						this.report = res.data[0] 	
						
						this.report.area = this.calculate( this.report.area)
						this.report.distance = this.calculate( this.report.distance)
						this.report.duration = this.calculate( this.report.duration)
						
						this.report.areaAverage = this.calculate( this.report.areaAverage)
						this.report.distanceAverage = this.calculate( this.report.distanceAverage)
						this.report.durationAverage = this.calculate( this.report.durationAverage)
						
						//虚拟数据
						if(this.loginuser === 'admin'){
							this.report.rateUse = 95
							this.report.rateWorkCompleted = 92
						}
														  
						this.rateCarUseList = this.report.carUseList
						if(this.rateCarUseList != null && this.rateCarUseList.length > 0){
							this.rateCarUseList.forEach((item,index)=>{
								item.rateCarUse = (item.rateCarUse * 100 ).toFixed(1) + '%'
								return item
							})
						}					
						this.initChart()
				  }else{
					   this.$message.error("未查询到数据");
				  }
				});		
			},
			calculate(num){
				if(num >= 10000){
					var num2 = (num/10000).toFixed(2)
					return num2+"万"
				}else{
					return num
				}
			},
			downCsv(){
				this.$message.info("暂无权限");
			},
			initChart() {
				// if(myChart1 == null){
					myChart1 = echarts.init(this.$refs.chart1)
					myChart1.setOption(option)
					window.onresize = myChart1.resize
				// }
				
				// if(myChart2 == null){
					myChart2 = echarts.init(this.$refs.chart2)
					myChart2.setOption(option)
					window.onresize = myChart2.resize
				// }
				
				let xDate
				if(this.listQuery.dateType == 2){
					xDate = this.getMonthEvryDay(this.listQuery.startTime)
				}else if(this.listQuery.dateType == 3){
					xDate = ['01','02','03','04','05','06','07','08','09','10','11','12']
				}else if(this.listQuery.dateType == 4){
					xDate = this.getYearRange(this.listQuery.startTime,this.listQuery.endTime)
				}else{
					xDate = this.getDateRange(this.listQuery.startTime,this.listQuery.endTime)
				}
				
				mData1 = new Array(xDate.length).fill(''),mData2 = new Array(xDate.length).fill('0'),
				aData1 = new Array(xDate.length).fill(''),aData2 = new Array(xDate.length).fill('0')
				
				let rList = this.report.rList , rLastList =  this.report.rLastList, aList1 = this.report.aList1 , aList2 = this.report.aList2 
				let ml1 = this.report.markline1,ml2 = this.report.markline2
				
				for(var i = 0 ; i < xDate.length ; i ++){
					if(rList != null && rList.length > 0){
						rList.forEach((item,index)=>{
							if(xDate[i] == item.xDate){
								aData1[i] = (item.area / 10000).toFixed(2)
								aData2[i] = item.duration
								return
							}
						})
					}///
					
					let crd = rList[i]
					if(aList1 != null && aList1.length > 0){
						aList1.forEach((mitem,index)=>{					
							// if(crd != null){
							// 	if(xDate[i] == item.xDate  && item.xDate == crd.xDate){
							// 		let m_area = (item.area - crd.area) >= 0 ? (item.area - crd.area) : 0
							// 		mData1[i] = (m_area / 10000).toFixed(2)
							// 	}else{
							// 		if(xDate[i] == item.xDate ){
							// 			mData1[i] = (item.area / 10000).toFixed(2)
							// 		}
							// 	}				
							// }else{
							// 	if(xDate[i] == item.xDate ){
							// 		mData1[i] = (item.area / 10000).toFixed(2)
							// 		return
							// 	}								
							// }///		
							rList.forEach((aitem,index)=>{
								if(xDate[i] == mitem.xDate  && mitem.xDate == aitem.xDate){
									let m_area = (mitem.area - aitem.area) >= 0 ? (mitem.area - aitem.area) : 0
									mData1[i] = (m_area / 10000).toFixed(2)
								}
								// else{
								// 	if(xDate[i] == mitem.xDate){
								// 		mData1[i] = (mitem.area / 10000).toFixed(2)
								// 	}
								// }//
							})								
																
						})
					}//
					
					if(aList2 != null && aList2.length > 0){							
							aList2.forEach((mitem,index)=>{							
								// if(crd != null){
								// 	if(xDate[i] == item.xDate  && item.xDate == crd.xDate){
								// 		let m_duration = (item.duration - crd.duration) >= 0 ? (item.duration - crd.duration) : 0
								// 		mData2[i] = m_duration.toFixed(2)
								// 	}else{
								// 		if(xDate[i] == item.xDate){
								// 			mData2[i] = (item.duration).toFixed(2)
								// 		}
								// 	}	
								// }else{
								// 	if(xDate[i] == item.xDate){
								// 		mData2[i] = (item.duration).toFixed(2)
								// 	}		
								// }///		
								rList.forEach((aitem,index)=>{
									if(xDate[i] == mitem.xDate  && mitem.xDate == aitem.xDate){
										let m_duration = (mitem.duration - aitem.duration) >= 0 ? (mitem.duration - aitem.duration) : 0
										mData2[i] = m_duration.toFixed(2)
									}
									// else{
									// 	if(xDate[i] == mitem.xDate){
									// 		mData2[i] = (mitem.duration).toFixed(2)
									// 	}
									// }//
								})///													
							})
					}	///			
					
				}
						
				
				
				// if(aList1 != null && aList1.length > 0){
				// 	for(var i = 0 ; i < xDate.length ; i ++){
				// 		let crd = rList[i],ard = aList1[i]			
				// 		if(xDate[i] == aList1.xDate == crd.xDate){
				// 			mData1[i] = ((crd.area - aList1.area) / 10000).toFixed(2)
				// 		}else{
				// 			mData1[i] = (aList1.area / 10000).toFixed(2)
				// 		}
				// 	}
				// }
				
				// if(aList2 != null && aList2.length > 0){
				// 	for(var i = 0 ; i < xDate.length ; i ++){
				// 		let crd = rList[i],ard = aList2[i]			
				// 		if(xDate[i] == aList2.xDate == crd.xDate){
				// 			mData1[i] = (crd.duration - aList2.duration) .toFixed(2)
				// 		}else{
				// 			mData1[i] =  aList2.duration.toFixed(2)
				// 		}
				// 	}
				// }
				
				
				let seriesData1 = {
					xAxis: [
					  {
					    data: xDate
					  }
					],
					series: [	
						{
							markLine: {
							        data: [
							            {type: 'average', name: '平均值'},
							            // {yAxis: ml1} // 在Y轴最大值处画一条线
							        ],
							        lineStyle: { // 设置线条样式
							            color: '#ff5500', // 设置线条颜色为红色
							            type: 'dashed', // 设置线条类型为虚线
							            width: 2 // 设置线条宽度
							        },
							        label: {
							            show: true, // 显示标签
							            position: 'end' // 标签的位置
							        }
							},
							data:aData1
						},
						{
							data:mData1
						}
					]
				} 
				
				let seriesData2 = {
					xAxis: [
					  {
					    data: xDate
					  }
					],
					yAxis: [
					  {
					    name: '清扫时长',
					  },
					],	
					series: [	
						{
						  name: legends[0],
						  type: 'line',
						  // label: labelOption,
						  emphasis: {
						    focus: 'series'
						  },
						  itemStyle:{
							  color:colors2[0]
						  },
						  data: aData2,
						  markLine: {
						          data: [
						              {type: 'average', name: '平均值'},
						              // {yAxis: ml2} // 在Y轴最大值处画一条线
						          ],
						          lineStyle: { // 设置线条样式
						              color: '#ff5500', // 设置线条颜色为红色
						              type: 'dashed', // 设置线条类型为虚线
						              width: 2 // 设置线条宽度
						          },
						          label: {
						              show: true, // 显示标签
						              position: 'end' // 标签的位置
						          }
						  }
						},
						{
						  name: legends[1],
						  type: 'line',
						  // label: labelOption,
						  emphasis: {
						    focus: 'series'
						  },
						  itemStyle:{
						  	color:colors2[1]
						  },
						  data: mData2
						}
					]
				}
				
				myChart1.setOption(seriesData1)	
				myChart2.setOption(seriesData2)		
				
			},				
			handleWeekChange(value) {
			      if (value) {
			        // console.log(value)
			        
			        const selectedDate = new Date(value)
					 // 计算周日的日期（开始日期）
					const weekStart = new Date(selectedDate);
					weekStart.setDate(selectedDate.getDate() - selectedDate.getDay());					
					 // 计算周六的日期（结束日期）
					const weekEnd = new Date(weekStart);
					weekEnd.setDate(weekStart.getDate() + 6);
					
					
					// 获取周的第一天（周一）
			  //       const weekStart = new Date(value)
			  //       const dayOfWeek = weekStart.getDay() // 周日是0，周一是1，...
			  //       // 如果周的第一天不是周一，则回退到上一周的周一
			  //       if (dayOfWeek !== 1) {
			  //         weekStart.setDate(weekStart.getDate() - dayOfWeek+1)
			  //       }
			  //       // 计算周的最后一天（周日）
			  //       const weekEnd = new Date(weekStart)
			  //       weekEnd.setDate(weekEnd.getDate() + 6)				
					
					this.dateQuery.range = []
					this.dateQuery.month = ''
					this.dateQuery.year = ''
					this.dateQuery.yearRange = []
			 
			        // 存储周的开始和结束日期
					this.listQuery.dateType = 1
			        this.listQuery.startTime = this.formatDate(weekStart)
			        this.listQuery.endTime = this.formatDate(weekEnd)
			      }
			    },
			    // 月选择器获取月份日期范围
			    handleMonthChange(value) {
			      // 确保value是一个有效的Date对象
			      if (value) {
			        // 获取月份的第一天
			        const firstDay = new Date(value.getFullYear(), value.getMonth(), 1)			 
			        // 获取下一个月的第一天
			        const nextMonthFirstDay = new Date(value.getFullYear(), value.getMonth() + 1, 1)		 
			        // 获取当前月份的最后一天（即下一个月第一天的前一天）
			        const lastDay = new Date(nextMonthFirstDay - 86400000) // 一天有86400000毫秒
			 
					this.dateQuery.week = ''
					this.dateQuery.range = []
					this.dateQuery.year = ''
					this.dateQuery.yearRange = []
			 
			        // 更新组件数据
					this.listQuery.dateType = 2
			        this.listQuery.startTime = this.formatDate(firstDay)
			        this.listQuery.endTime =  this.formatDate(lastDay)
			      }
			    },
				handleYearChange(value){
					if(value){
						// 获取月份的第一天
						const firstDay = new Date(value.getFullYear(), value.getMonth(), 1)								
			
						// 创建一个新的Date对象，设置为指定年份的12月31日
						const lastDay = new Date(value.getFullYear(), 11, 31);					    
						// 获取并返回年份、月份和日期部分
						const lastDayString = `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
						    	
							
						this.dateQuery.week = ''
						this.dateQuery.range = []					
						this.dateQuery.month = ''
						this.dateQuery.yearRange = []
									 
						// 更新组件数据
						this.listQuery.dateType = 3
						this.listQuery.startTime = this.formatDate(firstDay)
						this.listQuery.endTime = lastDayString					
					}
				},	
			handleLastWeekDate() {
			    const today = new Date();		
				// 计算上周第一天（周日）的日期
				let dayOfWeek = today.getDay(); // 获取今天是星期几（0表示周日）
				let startOfLastWeek = new Date(today);
				startOfLastWeek.setDate(today.getDate() - dayOfWeek - 7); // 调整为上周日的日期
				
				// 计算上周最后一天（周六）的日期
				let endOfLastWeek = new Date(startOfLastWeek);
				endOfLastWeek.setDate(startOfLastWeek.getDate() + 6); // 加上6天得到上周六的日期
								 
				// 存储周的开始和结束日期
				this.listQuery.dateType = 1
			    this.listQuery.startTime = this.formatDate(startOfLastWeek)
			    this.listQuery.endTime = this.formatDate(endOfLastWeek)			
			    //return lastWeekMonday;
			},
			handleLastMonthDate(){			
				const today = new Date();
				const lastMonth = today.getMonth() - 1 === -1 ? 11 : today.getMonth() - 1; // 处理跨年的情况
				const firstDay = new Date(today.getFullYear(), lastMonth, 1);
				const lastDay = new Date(today.getFullYear(), lastMonth + 1, 0);
				
				// 存储月的开始和结束日期
				this.listQuery.dateType = 2
				this.listQuery.startTime = this.formatDate(firstDay)
				this.listQuery.endTime =  this.formatDate(lastDay)
			},
			formatDate(date) {
			      const year = date.getFullYear()
			      const month = (date.getMonth() + 1).toString().padStart(2, '0') // 填充前导零
			      const day = date.getDate().toString().padStart(2, '0') // 填充前导零
			      return `${year}-${month}-${day}`
			},
			getYearRange(start,end){
				const years = [];
				if (start > end) [start, end] = [end, start];
				let cur = start
				while(cur <= end){						
					years.push(cur)
					cur += 1
				}
				return years
			},
			getDateRange(startDate, endDate) {
			  const dates = [];
			  // 确保 startDate <= endDate
			  const start = new Date(startDate);
			  const end = new Date(endDate);
			  if (start > end) [start, end] = [end, start]; // 交换顺序
			
			  // 逐天递增，直到覆盖结束日期
			  let currentDate = new Date(start);
			  while (currentDate <= end) {
				  let current = this.formatDate(new Date(currentDate))
				  dates.push(current.substr(current.indexOf('-') + 1)); // 保存日期对象
				  currentDate.setDate(currentDate.getDate() + 1); // 增加一天
			  }			
			  return dates;
			},
			 //获取一个月的天数
			getCountDays(ym) {
				  var curDate = new Date(ym);					  
				  /* 获取当前月份 */
				  var curMonth = curDate.getMonth();
				  /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
				  curDate.setMonth(curMonth + 1);
				  /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
				  curDate.setDate(0);
				  /* 返回当月的天数 */
				  return curDate.getDate();
			 },
			//获取一个月日期		
			getMonthEvryDay(ym){	
				var month,day 
				var yms = ym.split('-')
				month = new Date().getMonth() + 1;	 
			
				if(yms[1] == month){
					day = new Date().getDate();
				}else{
					month = new Date(ym).getMonth() + 1;	
					day = this.getCountDays(ym);
				}		   
				
				if(month < 10 ){
					month = '0'+month
				}		   
				var dayArry=[];
				for (var k = 1; k <= day; k++) {
					 let d = k
					 if(d < 10){
						 d = '0'+d
					 }
					 dayArry.push(month+"-"+d);
				}
				return dayArry;
			}
			///
		},
		//
	}
	
	
	let myChart1 = null, myChart2 = null
	const legends = ['自动清扫', '人工清扫']
	const colors = ['#5470c6','#91cc75','#e8b952','#ee6666']
	const colors2 = ['#6b90fd','#b4fc90','#ffcb5a','#fd6c6c']
	const units = ['万平方米','小时']
	
	let mData1 = new Array(5).fill('0'),mData2 = new Array(5).fill('0'),
		aData1 = new Array(5).fill('0'),aData2 = new Array(5).fill('0')
	
	const labelOption = {
	  show: true,
	  rotate: -90,
	  // formatter: '{c}  {name|{a}}',
	  rich: {
	    name: {}
	  }
	}
	
	let option = {
	  tooltip: {
	    trigger: 'axis', //'item' | 'axis'
	    axisPointer: {
	      type: 'shadow',
	    },
		 formatter: function (params) {
			let res = '', axis = ''
			params.forEach(function (item) {
				axis = item.axisValue
				var data = item.data,name = item.seriesName,type = item.seriesType
				let unit = units[0]	
				if(type === 'line'){
					unit = units[1]	
				}
			    res += `${name}:${data}${unit}<br/>`
			});	    
		    return `${axis} <br/> ${res}` 
		}
	  },
	  legend: {
	    data: legends,
		textStyle:{
			color:'#fff'
		}
	  },
	  grid: {
	    // left: '10%',
	    // right: '10%',
	    bottom: '2%',
	  	containLabel: true // 防止标签溢出边界
	  },
	  xAxis: [
	    {
	      type: 'category',
	      axisTick: { show: false },
		  axisLabel: {
		    show: true,
		    fontSize: 12, // 设置x轴标签的字体大小
			// fontWeight: 'bold',
			 color:'#fff'
		  },
		  nameTextStyle:{
			  fontSize: 14 ,
			  // fontWeight: 'bold' 
		  },
	      data: ['2012', '2013', '2014', '2015', '2016']
	    }
	  ],
	  yAxis: [
	    {
	      name: '清扫面积',
	      type: 'value',
	      position: 'left',
	      alignTicks: true,
	      axisLine: {
	        show: true,
	        lineStyle: {
	          color: '#fff'
	        }
	      },
		  axisLabel: {
		    show: true,
		    fontSize: 12 ,// 设置x轴标签的字体大小
			// fontWeight: 'bold' 
		  },
		  nameTextStyle:{
		  		fontSize: 12 ,
				// fontWeight: 'bold' 
		  }
	    }
	  ],
	  series: [
	    {
	      name: legends[0],
	      type: 'bar',
	      barGap: 0,
	      // label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
			  color:colors2[0]
		  },
	      data: [320, 332, 301, 334, 390] //yData1
	    },
	    {
	      name: legends[1],
	      type: 'bar',
	      // label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
		  	color:colors2[1]
		  },
	      data: [220, 182, 191, 234, 290]  //yData2
	    }
	  ]
	};
	
</script>

<style  lang="scss" scoped>
	.container{
		z-index: 1000;
		position: fixed;
		top:9%;
		right:0;
		width: 22%;
		// bottom: 10%;
		display: flex;
		flex-direction: column;
		text-align: center;	
		background:rgba(22,26,99,.8);
		color: #FFFFFF;
		
		.col{
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
		.row{
			display: flex;
			flex-direction: row;
			justify-content: center;
		}
		.row2{
			display: flex;
			flex-direction: row;
			justify-content: left;
		}
		
		.wktabdiv{
			list-style: none;
			// padding: 20px;
			margin: 0;
		}
		.wktabtit{
			line-height: 30px;
			font-size: 15px;
			letter-spacing: 2px;
			font-weight: 800;
			text-align: center;
			padding: 0 5px;
		}
		
		.active {
			color: rgb(3,166,224)
		}
		
		.box{
			padding:5px 10px;
			
			.box2{
				padding: 5px;
			}
			
			font{
				font-size: 12px;
				line-height: 20px;
				white-space: nowrap; 
				// padding: 2px;
			}
			
			.fontg{
				color:#19F2EB;
				font-size: 14px;
			}
			
			.fontr{
				color:#ff0000;
				font-size: 14px;
			}
			
			.fontsize{
				font-size: 12px;
			}
			
			.font2{
				// padding: 5px 0;
			}
		}
		
		.ranking-container{
			.nav-title{
				position: relative;
				width: 140px;
				height: 40px;
				margin: 8px 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				font-size: 14px;
				border: none;
				cursor: pointer;
			}
			.nav-title::before{
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: rgba(22,26,99,1);
				transform: skew(-20deg);
				z-index: -1;
			}
			.nav-title2{
				position: relative;
				width: 200px;
				height: 30px;
				background: linear-gradient(to right, rgb(22,26,99), transparent);
				transform: skew(-20deg);
				z-index: -1;
				align-self: center;
			}
			
			img{
				height: 30px;
				width: 30px;
				transform: rotate(-45deg);
			}
			
			.carrnaking{
				line-height: 30px;
			}
		}
		
		.dv-border-box-7{
			margin: 0 5px;
		}
		
		.dv-border-box-2{
			margin: 0 5px;
		}
		
		.dv-border-box-6{
			margin: 0 5px;
		}
		
		.dv-border-box-8{
			height: 180px;
			width: 98%;
			margin: 5px;
			padding: 5px 0;
		}
		
		.mychart-height{
			//height: 180px;
			
			height: calc(100vh * 0.2);
		}
		
		
	}
</style>
